import type { SelfView } from "@bezbolisno/contracts/telegram";
import { t } from "@bezbolisno/i18n";
import { formatUAH } from "@bezbolisno/kit/money-format";
import { dayLabel, invoiceStatus } from "./labels";
import { Section } from "./Section";

/** Newest first: what was billed, for how much, and whether it is paid. */
export function InvoiceList({ invoices }: { invoices: SelfView["invoices"] }) {
  const rows = [...invoices].sort((a, b) => Date.parse(b.issuedAt) - Date.parse(a.issuedAt));

  return (
    <Section title={t.telegram.invoices}>
      {rows.length === 0 ? (
        <div className="tg-hint">{t.telegram.noInvoices}</div>
      ) : (
        rows.map((i) => (
          <div key={i.id} className="tg-row">
            <span>
              <span className="tg-num">№{i.number}</span>
              <span className="tg-hint"> · {dayLabel(i.issuedAt)}</span>
            </span>
            <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <span className="tg-num">{formatUAH(i.totalMinor)}</span>
              <span className={i.status === "paid" ? "tg-chip" : "tg-chip tg-chip--muted"}>
                {invoiceStatus(i.status)}
              </span>
            </span>
          </div>
        ))
      )}
    </Section>
  );
}
